<form class="w-100 mx-auto">
  <p class="text-center d-block mb-3 w-100 fs-3">2FA Required</p>
  <div class="form-item mb-3 mx-0 w-100">
    <label for="2fa-code" class="form-label">Code</label>
    <input
      type="text"
      data-test="2fa-code"
      id="2fa-code"
      class="form-control text-center form-control-lg"
      placeholder="Enter Code"
      [(ngModel)]="code"
      name="code"
      required
    />
  </div>

  @if (mfaConfig && mfaConfig.challengeParameters) {
    <div>
      @if (mfaConfig.challengeName?.value === 'SOFTWARE_TOKEN_MFA') {
        <p class="text-dark w-100 d-block text-center">
          Enter the code from your authentication app
        </p>
      } @else {
        <p class="text-dark w-100 d-block text-center">
          Code Sent via
          {{ mfaConfig.challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM }} to
          {{ mfaConfig.challengeParameters.CODE_DELIVERY_DESTINATION }}
        </p>
      }
    </div>
  }

  <button
    class="w-100 mt-2 form-item mon-bg-primary mon-text-primary"
    data-test="submit-button"
    mat-flat-button
    (click)="Submit()"
  >
    <span>SUBMIT</span>
  </button>
</form>

<div class="mt-2">
  @if (errorMessage && errorMessage !== '') {
    <div class="alert alert-danger mb-3" role="alert">
      {{ errorMessage }}
    </div>
  }
</div>

<odin-loading-spinner
  [active]="loading"
  [overlay]="true"
></odin-loading-spinner>
